import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { FluidInfo, VendorJob } from '../../../../services/nswag/nswagclient';

@Component({
  selector: 'app-job-fluid-information',
  standalone: false,
  templateUrl: './job-fluid-information.component.html',
  styleUrls: ['./job-fluid-information.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => JobFluidInformationComponent),
    multi: true
  }]
})
export class JobFluidInformationComponent implements OnInit, ControlValueAccessor {

  private _onTouched: () => void = () => {};

  @Input() _job: VendorJob = new VendorJob();
  get job() {
    return this._job;
  }
  set job(val: VendorJob) {
    this._job = val ?? new VendorJob();
    this.ensureJobDefaults(this._job);
    this.propagateChange(this._job);
  }
  @Input() modelInvalid = false;
  @Input() disabled = false;

  constructor() { }

  ngOnInit() {
    this.ensureJobDefaults(this._job);
  }

  /****** ControlValueAccessor methods to handle ngModel read and updates ******/
  propagateChange = (_: any) => { };

  writeValue(obj: any): void {
    if (obj) {
      this._job = obj;
      this.ensureJobDefaults(this._job);
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private ensureJobDefaults(job: VendorJob): void {
    if (!job.fluidInfo) {
      job.fluidInfo = new FluidInfo();
    }
  }

}
